// styles
import './Navbar.css';


const Navbar = () => {
	
	
	return (
		<nav id="navbar">
			<p><a href="#welcome-section">About</a></p>
			<p><a href="#projects-section-title">Work</a></p>
			<p><a href="#contact">Contacts</a></p>
		</nav>
	);
};



export default Navbar


